import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import emptyAvatar from "../../assets/img/empty_avatar.png";
import { Form, Button } from "react-bootstrap";
import { formatDate } from "../../helpers/actions";
import { getHtmlNewlines } from "../../helpers/templateHelpers";
import { toast } from "react-toastify";
import * as _ from "lodash";
import { useGetUser } from "../../hooks/global/User";
import { answerToReview } from "../../posters/answer";

function ReplyReview(props) {
  const { t, i18n } = useTranslation();
  const review = props.review;
  const editable = props.editable;
  const vendor = props.vendor;
  const refreshReview = props.refreshReview;
  const useRefReply = useRef("reply");
  const user = useGetUser();

  const [showInfo, setShowInfo] = useState(false);
  const [replyStarted, setReplyStarted] = useState(false);
  const [replyState, setReplyState] = useState("");

  let showInfoClass = "infoIcon";

  showInfo && (showInfoClass += " show");

  const submitReply = () => {
    let payload = { text: replyState.trim(), authorEmail: user.email };

    answerToReview(review.id, payload)
      .then((reply) => {
        refreshReview(reply);
        toast.success(t("admin.reviews.replyText1"), {
          className: "successToast",
        });
      })
      .catch((err) => {
        toast.error(t(err), { className: "errorToast" });
      });
  };

  return (
    <div>
      {review.reply ? (
        <div className="reply">
          <div className="item clearfix">
            <div className="avatar">
              <img src={emptyAvatar} alt="avatar" />
              <h6>{vendor.name}</h6>
            </div>
            <div className="comment">
              {editable && (
                <div className={showInfoClass}>
                  <span onClick={() => setShowInfo(!showInfo)}></span>
                  <p>
                    {t("admin.reviews.replyText1")}{" "}
                    {t("admin.reviews.replyText2")}
                  </p>
                </div>
              )}
              <p className="date">
                {formatDate(review.reply.created, i18n.language)}
              </p>
              <h3>{t("admin.common.comReply")}</h3>
              <p
                className="text"
                dangerouslySetInnerHTML={{
                  __html: getHtmlNewlines(review.reply.text),
                }}
              ></p>
            </div>
          </div>
        </div>
      ) : (
        <div>
          {editable && review.status === "APPROVED" && (
            <div>
              {replyStarted ? (
                <Form className="replyForm">
                  <Form.Control
                    as="textarea"
                    ref={useRefReply}
                    rows="4"
                    cols="50"
                    className="form-control"
                    placeholder={t("admin.common.answer") + " ..."}
                    value={replyState}
                    onChange={(e) => setReplyState(e.target.value)}
                  />
                  <Button onClick={() => submitReply()}>
                    {t("admin.common.subReply")}
                  </Button>
                </Form>
              ) : (
                <a
                  className="replyLink"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setReplyStarted(true);
                  }}
                >
                  {t("admin.common.reply")} »
                </a>
              )}{" "}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ReplyReview;
